module.exports = {"ru":{"title":"Увеличить","close":"Закрыть"},"en":{"title":"Zoom in","close":"Close"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/zoom-in/text.yaml
// module id = 152
// module chunks = 0